import { combineReducers } from 'redux';
import {
  CUSTOMER_LIST_HIDE_IMPORTING_MODE_MODAL,
  CUSTOMER_LIST_SET_CURRENT_PAGE,
  CUSTOMER_LIST_SET_CUSTOMER_DETAIL,
  CUSTOMER_LIST_SET_CUSTOMERS,
  CUSTOMER_LIST_SET_HAS_LOYALTY,
  CUSTOMER_LIST_SET_KEYWORD,
  CUSTOMER_LIST_SET_POINT_ACTIVITIES,
  CUSTOMER_LIST_SET_RECEIPT,
  CUSTOMER_LIST_SET_REDEMPTION_HISTORIES,
  CUSTOMER_LIST_SET_SUMMARY,
  CUSTOMER_LIST_SET_TOTAL_PAGE,
  CUSTOMER_LIST_SET_TYPE,
  CUSTOMER_LIST_SET_PAYMENT_LIST,
  CUSTOMER_LIST_SHOW_IMPORTING_MODE_MODAL,
} from 'actions/customers/list/constants';
import createReducer from 'utils/createReducer';

const currentPage = createReducer(null, {
  [CUSTOMER_LIST_SET_CURRENT_PAGE]: (draft, { payload }) => payload.currentPage,
});

const customerDetail = createReducer(null, {
  [CUSTOMER_LIST_SET_CUSTOMER_DETAIL]: (draft, { payload }) => payload.customer,
});

const customers = createReducer([], {
  [CUSTOMER_LIST_SET_CUSTOMERS]: (draft, { payload }) => payload.customers,
});

const hasLoyalty = createReducer(null, {
  [CUSTOMER_LIST_SET_HAS_LOYALTY]: (draft, { payload }) => payload.hasLoyalty,
});

const keyword = createReducer(null, {
  [CUSTOMER_LIST_SET_KEYWORD]: (draft, { payload }) => payload.keyword,
});

const pointActivities = createReducer(null, {
  [CUSTOMER_LIST_SET_POINT_ACTIVITIES]: (draft, { payload }) =>
    payload.pointActivities,
});

const receiptData = createReducer(null, {
  [CUSTOMER_LIST_SET_RECEIPT]: (draft, { payload }) => payload.receiptData,
});

const redemptionHistories = createReducer(null, {
  [CUSTOMER_LIST_SET_REDEMPTION_HISTORIES]: (draft, { payload }) =>
    payload.redemptionHistories,
});

const showImportingModeModal = createReducer(false, {
  [CUSTOMER_LIST_SHOW_IMPORTING_MODE_MODAL]: () => true,
  [CUSTOMER_LIST_HIDE_IMPORTING_MODE_MODAL]: () => false,
});

const summary = createReducer(
  {
    total_customer: 0,
    total_loyalty_member: 0,
    total_rewards_redeemed: 0,
  },
  {
    [CUSTOMER_LIST_SET_SUMMARY]: (draft, { payload }) => payload.summary,
  }
);

const totalPage = createReducer(null, {
  [CUSTOMER_LIST_SET_TOTAL_PAGE]: (draft, { payload }) => payload.totalPage,
});

const type = createReducer(null, {
  [CUSTOMER_LIST_SET_TYPE]: (draft, { payload }) => payload.type,
});

const paymentList = createReducer(null, {
  [CUSTOMER_LIST_SET_PAYMENT_LIST]: (draft, { payload }) => payload.paymentList,
});

export default combineReducers({
  currentPage,
  customerDetail,
  customers,
  hasLoyalty,
  keyword,
  pointActivities,
  receiptData,
  redemptionHistories,
  showImportingModeModal,
  summary,
  totalPage,
  type,
  paymentList,
});
